import {FormGroup} from "@angular/forms";

export class ProtocolStore {

  private static _instance: ProtocolStore;

  public static getInstance(): ProtocolStore {
    if (!ProtocolStore._instance) {
      ProtocolStore._instance = new ProtocolStore();
    }
    return ProtocolStore._instance;
  }

  private dialogCache: {
    activeTabIndex?: number
  };

  protected static getDialogCache() {
    if (!this.getInstance().dialogCache) {
      this.getInstance().dialogCache = {};
    }
    return this.getInstance().dialogCache;
  }

  protected static resetDialogCache() {
    this.getInstance().dialogCache = null;
  }

  public static setDialogActiveTab(index: number) {
    this.getDialogCache().activeTabIndex = index;
  }

  public static getDialogActiveTab() {
    return this.getDialogCache().activeTabIndex || 0;
  }

  private searchCache: {
    form?: FormGroup
  };

  protected static getSearchCache() {
    if (!this.getInstance().searchCache) {
      this.getInstance().searchCache = {};
    }
    return this.getInstance().searchCache;
  }

  public static cleanSearchCache() {
    this.getInstance().searchCache = null;
  }

  public static setSearchForm(form: FormGroup) {
    this.getSearchCache().form = form;
  }

  public static getSearchForm() {
    return this.getSearchCache().form;
  }

  private insertCache: {
    form?: FormGroup
  };

  protected static getInsertCache() {
    if (!this.getInstance().insertCache) {
      this.getInstance().insertCache = {};
    }
    return this.getInstance().insertCache;
  }

  public static cleanInsertCache() {
    this.getInstance().insertCache = null;
  }

  public static setInsertForm(form: FormGroup) {
    this.getInsertCache().form = form;
  }

  public static getInsertForm() {
    return this.getInsertCache().form;
  }
}
